import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageComponent } from '../../atoms/image/image.component';
import { CaasComponent } from '../../../shared/interfaces/caas/caas.interface';
import { PodcastService } from '../../../services/podcast.service';
import { PodcastPlatforms } from '../../../shared/interfaces/podcast-item.interface';

@Component({
  selector: 'hdi-logo-wall',
  standalone: true,
  imports: [CommonModule, ImageComponent],
  templateUrl: './logo-wall.component.html',
  styleUrls: ['./logo-wall.component.scss'],
  host: {
    id: crypto.randomUUID().toString(),
  },
})
export class LogoWallComponent implements OnChanges {
  @Input() podcastPlatforms: string[] = [];
  @Input() caasPodcastPlatforms?: PodcastPlatforms;
  @Input() caasData?: CaasComponent;
  @Input() headline?: string;

  googleLogo: { logoSrc?: string; alt?: string; label?: string; url?: string } =
    {};
  appleLogo: { logoSrc?: string; alt?: string; label?: string; url?: string } =
    {};
  deezerLogo: { logoSrc?: string; alt?: string; label?: string; url?: string } =
    {};
  spotifyLogo: {
    logoSrc?: string;
    alt?: string;
    label?: string;
    url?: string;
  } = {};
  overcastLogo: {
    logoSrc?: string;
    alt?: string;
    label?: string;
    url?: string;
  } = {};

  constructor(private podcastService: PodcastService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['caasData']) {
      this.setCaasContent();
    }
  }

  initializeLogoWallItems(platform: PodcastPlatforms['platforms'][number]) {
    switch (platform.label) {
      case 'GooglePodcasts':
        this.googleLogo = {
          logoSrc: './assets/images/google_logo.webp',
          alt: platform.alt,
          label: platform.label,
          url: platform.url,
        };
        break;
      case 'ApplePodcasts':
        this.appleLogo = {
          logoSrc: './assets/images/apple_logo.webp',
          alt: platform.alt,
          label: platform.label,
          url: platform.url,
        };
        break;
      case 'deezer':
        this.deezerLogo = {
          logoSrc: './assets/images/deezer_logo.webp',
          alt: platform.alt,
          label: platform.label,
          url: platform.url,
        };
        break;
      case 'Spotify':
        this.spotifyLogo = {
          logoSrc: './assets/images/spotify_logo.webp',
          alt: platform.alt,
          label: platform.label,
          url: platform.url,
        };
        break;
      case 'Overcast':
        this.overcastLogo = {
          logoSrc: './assets/images/overcast_logo.webp',
          alt: platform.alt,
          label: platform.label,
          url: platform.url,
        };
        break;
      default:
        break;
    }
  }

  setCaasContent() {
    if (this.caasData?.formData?.st_header?.value) {
      this.headline = this.caasData.formData.st_header.value;
      const platforms = this.podcastService.getPodcastPlatformBySerieId(
        this.caasData?.formData?.st_podcast?.value?.identifier
      );
      if (platforms) {
        this.caasPodcastPlatforms = platforms;
        this.caasPodcastPlatforms?.platforms.forEach((platform) => {
          this.initializeLogoWallItems(platform);
        });
      }
    }
  }
}
